import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import Captcha from "demos-react-captcha";
import Select from "react-select";
import InputMask from "react-input-mask";

import API from "../../../../api/baseUrl";
import { serialize, original } from "../../../../functions/helper";
import config from "../../../../config.json";
import { enDate, faDate, customDayDate } from "../../../../functions/date";
import FastVisitModal from "../../../../components/modal/FastVisitModal";
import Loading from "../../../../components/loading";
import { useLocation } from "react-router-dom";
import Modal from "../../../../components/modal/Modal";

const dateMask = {
	mask: "9999/99/99",
	maskChar: "_",
	alwaysShowMask: false,
	formatChars: {
		9: "[0-9]",
		a: "[A-Za-z]",
		"*": "[A-Za-z0-9]",
	},
	permanents: [2, 5],
};

export default function TicketListPage() {
	const history = useHistory();
	const [loading, setLoading] = useState(true);

	const Login_User_Token = localStorage.getItem("user_login_token");
	const Login_User_cp = localStorage.getItem("user_login_cp");

	const { state } = useLocation();

	const [showModal, setShowModal] = useState(false);
	const [list, setList] = useState([]);

	useEffect(() => {
		fetchtData();
	}, []);

	const fetchtData = async () => {
		try {
			setLoading(true);
			const resExpert = await API.post(
				serialize({
					id: 4561,
					sp_param: `'${localStorage.getItem(
						"user_login_token",
					)}','${localStorage.getItem("user_login_cp")}','1','1','1','1','1'`,
					Login_User_Token: localStorage.getItem("user_login_token"),
					Login_User_cp: localStorage.getItem("user_login_cp"),
				}),
			);

			let res = original(resExpert.data, false);

			setLoading(false);

			setList(res);
		} catch (error) {
			console.log(error);
		}
	};

	const handleShowModal = (item) => {
		swal({
			title: "تایید تیکت",
			text: `آیا از تایید تیکت با شناسه ${item?.id_ticketing} مطمئن هستید؟`,
			icon: false,
			buttons: ["انصراف", "ادامه"],
		}).then((val) => {
			if (val) {
				handleVerify(item?.id_ticketing);
			}
		});
	};

	const handleVerify = async (id) => {
		try {
			setLoading(true);

			const res = await API.post(
				serialize({
					id: 4564,
					sp_param: `'${localStorage.getItem(
						"user_login_token",
					)}','${localStorage.getItem(
						"user_login_cp",
					)}','1','1','1','1','1','${id}'`,
					Login_User_Token: localStorage.getItem("user_login_token"),
					Login_User_cp: localStorage.getItem("user_login_cp"),
				}),
			);

			let resP = original(res.data, false);

			if (resP[0].s_result > "0") {
				swal({
					text: `${resP[0]?.s_message}`,
					icon: "success",
					button: "تایید",
				});
				fetchtData();
			} else {
				swal({
					text: `${resP[0]?.s_message}`,
					icon: "warning",
					button: "متوجه شدم!",
				});
			}
			setLoading(false);
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div
			className="fast-visit-page"
			style={{
				background: `linear-gradient(45deg,${
					config.auth_back_color_1
						? config.auth_back_color_1
						: "rgba(86, 0, 110, 1)"
				} 10%,${
					config.auth_back_color_2
						? config.auth_back_color_2
						: "rgba(33, 150, 243, 1)"
				} 100%)`,
			}}
		>
			<div className="fast-visit-page__box">
				<div className="overflow" style={{ width: "100%" }}>
					<table
						className="table tickets-table "
						style={{ width: "max-content" }}
					>
						<thead>
							<tr>
								<td>شناسه تیکت</td>
								<td>سرویس</td>
								<td>کاربر</td>
								<td>تاریخ</td>
								<td>وضعیت</td>
							</tr>
						</thead>
						<tbody>
							{list.map((item) => (
								<tr>
									<td>{item.id_ticketing}</td>
									<td>{item.ns}</td>
									<td>{item.lunp}</td>
									<td>{item.sdate}</td>
									<td>
										{item.con_t === " " ? (
											<button
												onClick={() => handleShowModal(item)}
												style={{
													border: "none",
													background: "none",
													cursor: "pointer",
													fontWeight: 600,
													color: "#ef5350"
												}}
											>
												تایید
											</button>
										) : (
											<span style={{ color: "#64DD17", fontWeight: 600 }}>
												تایید شده
											</span>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div className="fast-visit-page__form_links">
					<Link to={{ pathname: "/ticket", state }}>افزودن تیکت</Link>
					<Link to={{ pathname: "/", state }}>صفحه اصلی</Link>
				</div>
			</div>
			{loading && <Loading />}
		</div>
	);
}
